import { render, staticRenderFns } from "./ClientPicker.vue?vue&type=template&id=4accbaf8"
import script from "./ClientPicker.vue?vue&type=script&lang=js"
export * from "./ClientPicker.vue?vue&type=script&lang=js"
import style0 from "./ClientPicker.vue?vue&type=style&index=0&id=4accbaf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports